import { render, staticRenderFns } from "./ModulesReworksStudentList.vue?vue&type=template&id=a2e7cb74&scoped=true"
import script from "./ModulesReworksStudentList.vue?vue&type=script&lang=js"
export * from "./ModulesReworksStudentList.vue?vue&type=script&lang=js"
import style0 from "./ModulesReworksStudentList.vue?vue&type=style&index=0&id=a2e7cb74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e7cb74",
  null
  
)

export default component.exports